import React, { useContext } from 'react';
import { Image, Platform, StyleSheet, Text, View } from 'react-native';
import PropTypes from 'prop-types';
import Utils from '../../../common/Utils';
import LayoutContext from '../../../contexts/Layout';

const Affiliate = ({ handleLinkPress, imageUrl, isMobile, link, linkText }) => {
    return (
        <View style={Styles.affiliateContainer}>
            <Image
                onPress={() => handleLinkPress(link)}
                resizeMode='contain'
                source={{
                    uri: `https:${imageUrl}`
                }}
                style={isMobile ? Styles.affiliateImageMobile : Styles.affiliateImage}
            />
            <Text onPress={() => handleLinkPress(link)} style={Styles.affiliateText}>
                {linkText}
            </Text>
        </View>
    );
};

export const Affiliates = ({ contentItems, handleLinkPress }) => {
    const { layout } = useContext(LayoutContext);
    const affiliateArray = Object.values(contentItems);

    if (affiliateArray?.length > 0) {
        const reorderedAffiliateArray = Utils.swapElementsInArray(affiliateArray, 1, 2);

        return (
            <View
                style={{
                    flexDirection: layout.device.isMobile ? 'column' : 'row',
                    justifyContent: !layout.device.isMobile ? 'space-between' : undefined,
                    marginHorizontal: layout.styleGuide.spacer1,
                    marginVertical: 10
                }}
            >
                <View>
                    {reorderedAffiliateArray
                        .filter((_, index) => index % 2 === 0)
                        .map(affiliate => (
                            <Affiliate
                                key={affiliate.id}
                                handleLinkPress={handleLinkPress}
                                imageUrl={affiliate.linkImage.cdnImagePath}
                                isMobile={layout.device.isMobile}
                                link={affiliate.link}
                                linkText={affiliate.linkText}
                            />
                        ))}
                </View>
                <View>
                    {reorderedAffiliateArray
                        .filter((_, index) => index % 2 !== 0)
                        .map(affiliate => (
                            <Affiliate
                                key={affiliate.id}
                                handleLinkPress={handleLinkPress}
                                imageUrl={affiliate.linkImage.cdnImagePath}
                                isMobile={layout.device.isMobile}
                                link={affiliate.link}
                                linkText={affiliate.linkText}
                            />
                        ))}
                </View>
            </View>
        );
    }

    return null;
};

const Styles = StyleSheet.create({
    affiliateContainer: {
        alignItems: 'center',
        flexDirection: 'row'
    },
    affiliateImage: {
        height: 50,
        margin: 5,
        width: 50
    },
    affiliateImageMobile: {
        height: 25,
        margin: 5,
        width: 25
    },
    affiliateText: {
        color: '#153d6e',
        flex: 1,
        flexShrink: 1,
        fontFamily: 'GothamMedium',
        fontSize: Platform.OS.equals('web') ? '14pt' : 14
    }
});

Affiliates.propTypes = {
    contentItems: PropTypes.object,
    handleLinkPress: PropTypes.func
};
